import { render, staticRenderFns } from "./TaxesQuickStart.vue?vue&type=template&id=1b349ee4&"
import script from "./TaxesQuickStart.vue?vue&type=script&lang=js&"
export * from "./TaxesQuickStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports